// Lightweight tactile feedback for touch devices.
// Falls back silently on desktop / unsupported browsers.
export function haptic(pattern: number | number[] = 10): void {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
        try {
            navigator.vibrate(pattern);
        } catch {
            // ignore — vibration is a best-effort enhancement
        }
    }
}
